import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import './FloatingFAQButton.css';

const FloatingFAQButton = ({ onClick, className = 'floating-faq-button' }) => {
  const { t } = useTranslation();

  return (
    <button 
      className={className}
      onClick={onClick}
      aria-label={t('faqTitle')}
    >
      <HelpCircle className="faq-icon" />
      <span className="faq-text">{t('faqTitle')}</span>
    </button>
  );
};

export default FloatingFAQButton; 